var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1450,
    height: 99,
    viewBox: "0 0 1450 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1445.28 0H1.73751C-0.52576 5.17455 -0.290247 10.2791 0.816775 18.1504C3.97439 40.6072 17.9723 53.8111 53.4884 67.8184C89.2936 81.9453 122.385 87.3503 180.85 88.6265C227.651 89.6469 236.087 88.9379 283.106 80.013C311.292 74.6636 351.559 68.2716 372.577 65.811C427.321 59.3968 515.495 59.9918 574.904 67.1734C623.305 73.0232 694.654 88.1622 711.45 96.1473C719.485 99.9647 721.931 99.9592 735.245 96.0806C822.862 70.5654 869.296 63.5923 962.382 61.9714C1043.67 60.5534 1080.69 63.7675 1163.56 79.4347C1206.13 87.4838 1222.78 89.1353 1261.26 89.1353C1346.19 89.1353 1418.74 68.0631 1441.87 36.6731C1451.25 23.9509 1452.68 12.6249 1445.28 0Z",
    fill: "#E6F3CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.d34551366c13b9962bd6412fb38046a6.svg";
export { ForwardRef as ReactComponent };